import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/admin/guard';
import { CatalogsPage } from '@/features/resources/catalogs/catalog-list';
import { requireSkillsFeature } from '@/features/resources/guard';

/** Areas of job roles and skills of people (RES-15, RES-16). */
export const Route = createFileRoute('/_app/admin/skills')({
  beforeLoad: async ({ context }) => {
    requirePermission(context.me, 'job_roles.manage');
    await requireSkillsFeature(context.queryClient);
  },
  component: CatalogsPage,
});
